import { Alert, Autocomplete, Box, Button, Card, CardContent, CardHeader, Collapse, Grid, IconButton, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useState } from 'react'
import { es } from 'date-fns/locale';
import { useParams } from 'react-router-dom'
import FechasListado from "./FechasListado";

const anioActual = (new Date()).getFullYear()
//console.log(`anioActual ${anioActual}`)
const anioSiguiente = anioActual + 1

const options = [`${anioActual}`, `${anioSiguiente}`]

export default function Fechas() {
    const params = useParams()
    const [configuracion, setConfiguracion] = useState({ idEntidad: params.idEntidad });
    // const [isEditing, setIsEditing] = useState(false)
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [value, setValue] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [guardado, setGuardado] = useState(false);
    const [severity, setSeverity] = useState('error')

    const cargarConfiguracion = async (anio) => {
        if (anio) {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionFechas/configuracion/${anio}/${params.idEntidad}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            }

            )
            if (res.status === 404) {
                setOpen(true)
                setSeverity('info')
                setMensaje('Esa configuración de fechas aún no existe, puede registrarla')
                setConfiguracion({ "anio": anio, idEntidad: params.idEntidad, inicioGestionPresupuestal: null, inicioPlaneacionPresupuestal: null, activarMontosPrioridad2: null, cierreAdquisiciones: null, cierreTransferencias: null, limitePartida5000: null })
            }
            else {
                setOpen(true)
                setSeverity('info')
                setMensaje('Esa configuración de fechas ya existe, puede modificarla sólo en las fechas que no han vencido')
                const data = await res.json()
                //console.log(data)
                if (data.inicioPlaneacionPresupuestal) {
                    const arrayFecha = data.inicioPlaneacionPresupuestal.split('-')
                    data.inicioPlaneacionPresupuestal = `${arrayFecha[1]}/${arrayFecha[2]}/${arrayFecha[0]}`
                }
                if (data.inicioGestionPresupuestal) {
                    const arrayFecha = data.inicioGestionPresupuestal.split('-')
                    data.inicioGestionPresupuestal = `${arrayFecha[1]}/${arrayFecha[2]}/${arrayFecha[0]}`
                }
                if (data.activarMontosPrioridad2) {
                    const arrayFecha = data.activarMontosPrioridad2.split('-')
                    data.activarMontosPrioridad2 = `${arrayFecha[1]}/${arrayFecha[2]}/${arrayFecha[0]}`
                }
                if (data.cierreAdquisiciones) {
                    const arrayFecha = data.cierreAdquisiciones.split('-')
                    data.cierreAdquisiciones = `${arrayFecha[1]}/${arrayFecha[2]}/${arrayFecha[0]}`
                }
                if (data.cierreTransferencias) {
                    const arrayFecha = data.cierreTransferencias.split('-')
                    data.cierreTransferencias = `${arrayFecha[1]}/${arrayFecha[2]}/${arrayFecha[0]}`
                }
                if (data.cierreGestionPresupuestal) {
                    const arrayFecha = data.cierreGestionPresupuestal.split('-')
                    data.cierreGestionPresupuestal = `${arrayFecha[1]}/${arrayFecha[2]}/${arrayFecha[0]}`
                }
                if (data.limitePartida5000) {
                    const arrayFecha = data.limitePartida5000.split('-')
                    data.limitePartida5000 = `${arrayFecha[1]}/${arrayFecha[2]}/${arrayFecha[0]}`
                }

                setConfiguracion(data)
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionFechas/guardar`, {
            method: "POST",
            body: JSON.stringify(configuracion),
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
        })
        const data = await res.json()
        setOpen(true)
        //console.log(JSON.stringify(data))
        if(res.status === 200)
            setSeverity('success')
        else
            setSeverity('error')
        if (data.message) {
            setMensaje(data.message)

        }
        else {
            setMensaje('La configuración se ha guardado')
            setGuardado(true)
        }
        setLoading(false)
    }
    return (
        <>
            <FechasListado idEntidad={params.idEntidad} guardado={guardado} setGuardado={setGuardado} />
            <Grid item xs={12} style={{ marginTop: 15 }}>
                <Card>
                    <CardHeader title='Configuración de Fechas' />
                    <CardContent>
                        <form id='guardarProyectoPlan' onSubmit={handleSubmit}>
                            <Grid container direction='row' justifyContent='space-between' spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Autocomplete
                                        value={value}
                                        onChange={async (event, newValue) => {
                                            setValue(newValue);
                                           // console.log(newValue)
                                            setConfiguracion({ "anio": newValue, idEntidad: params.idEntidad, inicioGestionPresupuestal: null, inicioPlaneacionPresupuestal: null, activarMontosPrioridad2: null, cierreAdquisiciones: null, cierreTransferencias: null, cierreGestionPresupuestal: null, limitePartida5000: null })

                                            setMensaje('')
                                            setOpen(false)
                                            if (newValue !== null) {
                                                await cargarConfiguracion(newValue)
                                                return
                                            }
                                        }}
                                        inputValue={inputValue}
                                        onInputChange={(event, newInputValue) => {
                                            setInputValue(newInputValue);
                                        }}
                                        id="anio"
                                        name="anio"
                                        options={options}
                                        sx={{ width: '100%' }}
                                        renderInput={(params) => <TextField {...params} label="Año" focused />}
                                    />
                                </Grid>
                                {value === null ? <></> :
                                    <>
                                        <Grid item xs={12} sm={4}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                                <DatePicker disablePast required label="Inicio de la planeación presupuestal"
                                                    value={configuracion.inicioPlaneacionPresupuestal}
                                                    onChange={(newValue) => {
                                                        setConfiguracion({ ...configuracion, "inicioPlaneacionPresupuestal": newValue })
                                                    }}
                                                    disabled={configuracion.inicioPlaneacionPresupuestal ? ((new Date()).getTime() > (new Date(configuracion.inicioPlaneacionPresupuestal)).getTime()) : false}
                                                    renderInput={(params) => <TextField {...params} name="inicioPlaneacionPresupuestal" id="inicioPlaneacionPresupuestal" required focused variant='outlined' style={{ width: '100%' }} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                                <DatePicker disablePast required label="Inicio de la gestión presupuestal"
                                                    value={configuracion.inicioGestionPresupuestal}
                                                    onChange={(newValue) => {
                                                        setConfiguracion({ ...configuracion, "inicioGestionPresupuestal": newValue })
                                                    }}
                                                    disabled={configuracion.inicioGestionPresupuestal ? ((new Date()).getTime() > (new Date(configuracion.inicioGestionPresupuestal)).getTime()) : false}
                                                    renderInput={(params) => <TextField {...params} name="inicioGestionPresupuestal" id="inicioGestionPresupuestal" required focused variant='outlined' style={{ width: '100%' }} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                                <DatePicker disablePast required label="Fecha para uso de presupuesto prioridad 2"
                                                    value={configuracion.activarMontosPrioridad2}
                                                    onChange={(newValue) => {
                                                        setConfiguracion({ ...configuracion, "activarMontosPrioridad2": newValue })
                                                    }}
                                                    disabled={configuracion.activarMontosPrioridad2 ? ((new Date()).getTime() > (new Date(configuracion.activarMontosPrioridad2)).getTime()) : false}
                                                    renderInput={(params) => <TextField {...params} name="activarMontosPrioridad2" id="activarMontosPrioridad2" required focused variant='outlined' style={{ width: '100%' }} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                                <DatePicker disablePast required label="Cierre de adquisiciones"
                                                    value={configuracion.cierreAdquisiciones}
                                                    onChange={(newValue) => {
                                                        setConfiguracion({ ...configuracion, "cierreAdquisiciones": newValue })
                                                    }}
                                                    disabled={configuracion.cierreAdquisiciones ? ((new Date()).getTime() > (new Date(configuracion.cierreAdquisiciones)).getTime()) : false}
                                                    renderInput={(params) => <TextField {...params} name="cierreAdquisiciones" id="cierreAdquisiciones" required focused variant='outlined' style={{ width: '100%' }} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                                <DatePicker disablePast required label="Cierre de transferencias"
                                                    value={configuracion.cierreTransferencias}
                                                    onChange={(newValue) => {
                                                        setConfiguracion({ ...configuracion, "cierreTransferencias": newValue })
                                                    }}
                                                    disabled={configuracion.cierreTransferencias ? ((new Date()).getTime() > (new Date(configuracion.cierreTransferencias)).getTime()) : false}
                                                    renderInput={(params) => <TextField {...params} name="cierreTransferencias" id="cierreTransferencias" required focused variant='outlined' style={{ width: '100%' }} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                                <DatePicker disablePast required label="Cierre de la gestión presupuestal"
                                                    value={configuracion.cierreGestionPresupuestal}
                                                    name="cierreGestionPresupuestal" id="cierreGestionPresupuestal"
                                                    onChange={(newValue) => {
                                                        setConfiguracion({ ...configuracion, "cierreGestionPresupuestal": newValue })
                                                    }}
                                                    disabled={configuracion.cierreGestionPresupuestal ? ((new Date()).getTime() > (new Date(configuracion.cierreGestionPresupuestal)).getTime()) : false}
                                                    renderInput={(params) => <TextField {...params} required focused variant='outlined' style={{ width: '100%' }} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                                <DatePicker disablePast required label="Limite partida 5000"
                                                    value={configuracion.limitePartida5000}
                                                    name="limitePartida5000" id="limitePartida5000"
                                                    onChange={(newValue) => {
                                                        setConfiguracion({ ...configuracion, "limitePartida5000": newValue })
                                                    }}
                                                    disabled={configuracion.limitePartida5000 ? ((new Date()).getTime() > (new Date(configuracion.limitePartida5000)).getTime()) : false}
                                                    renderInput={(params) => <TextField {...params} required focused variant='outlined' style={{ width: '100%' }} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Button variant='contained' color='primary' type='submit' disabled={loading}>
                                                Guardar
                                            </Button>
                                        </Grid>
                                    </>
                                }
                            </Grid>
                        </form>
                        <Box sx={{ width: '100%' }}>
                            <Collapse in={open}>
                                <Alert severity={severity}
                                    action={
                                        <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                                setOpen(false);
                                            }}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    }
                                    style={{ marginTop: 30 }}
                                >
                                    {mensaje}

                                </Alert>
                            </Collapse>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </>
    )
}